enum GlobalSearchResultType {
    OrganizationSections = "organization_sections",
    Projects = "projects",
    Flows = "flows",
    FlowGroups = "flow_groups",
    ProjectSections = "project_sections",
    Screens = "screens",
    DotComments = "dot_comments",
    Annotations = "annotations",
    Styleguides = "styleguides",
    Colors = "colors",
    TextStyles = "text_styles",
    ComponentSections = "component_sections",
    Components = "components",
    Assets = "assets"
}

export default GlobalSearchResultType;
